import { Component } from "react";
import { IBaseComponentProps, NSSpace, NSSpaceSizeType, NSTable, NSTitle } from "namirasoft-site-react";
import { RoleRow } from "namirasoft-access";
import { AccessProps } from "../AccessProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BaseMetaColumn, BaseMetaTable, FilterItem, FilterItemOperator, SortItem } from "namirasoft-core";
import { AccessEntities } from "../AccessEntities";

export interface RoleTableProps extends IBaseComponentProps, NSARouterMakerResult, AccessProps
{
	id: string;
	ids: string[];
}

export default class RoleTable extends Component<RoleTableProps>
{
	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, this.props.notifier.onError);
		let entity_role = AccessEntities.role(this.props);
		let meta_role = namirasoft.access.tables.role;
		return <>
			<NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
			<NSTitle title='Roles' />
			<NSTable<RoleRow>
				id={this.props.id}
				name={`roles-${this.props.id}`}
				checkbox={false}
				columns={entity_role.client.getColumns()}
				getRows={async (page: number, size: number, sorts: SortItem[]) =>
				{
					if (entity_role.server.list)
					{
						let table = new BaseMetaTable(null, meta_role.name, meta_role.text);
						let column = new BaseMetaColumn(table, meta_role.columns.id.name, meta_role.columns.id.text, "", false);
						let filters = this.props.ids.map(id => new FilterItem(table, column, false, FilterItemOperator.all.equals, id));
						return await entity_role.server.list(filters, page, size, sorts, null);
					}
					return { count: 0, rows: [] };
				}}
				getRowKey={e => e.value.id}
                style={{ height: "auto" }}
			/>
		</>
	}
}